// eslint-disable-next-line no-restricted-imports
import FeatureGates from '@atlaskit/feature-gate-js-client';
import {
  // eslint-disable-next-line no-restricted-imports
  AtlBrowserStorageLocal,
  // eslint-disable-next-line no-restricted-imports
  AtlBrowserStorageSession,
} from '@atlassian/browser-storage-controls';

/**
 * Function to check if the Atlassian Browser Storage feature is enabled.
 *
 * @returns boolean
 */
export function isAtlBrowserStorageEnabled(): boolean {
  if (!FeatureGates.initializeCompleted?.()) {
    return false;
  }

  const isAtlBrowserStorageGateEnabled = FeatureGates.checkGate(
    'tplat_atl_browser_storage',
  );

  const isAtlBrowserStorageLocal = AtlBrowserStorageLocal?.isAvailable;
  const isAtlBrowserStorageSession = AtlBrowserStorageSession?.isAvailable;

  // we want to fail gracefully if the feature gate or feature is not available
  const isAtlBrowserStorageAvailable = isAtlBrowserStorageGateEnabled
    ? Boolean(isAtlBrowserStorageLocal || isAtlBrowserStorageSession)
    : false;

  return isAtlBrowserStorageAvailable;
}
